import { css } from "@emotion/css"
import ja from "date-fns/locale/ja"
import ReactDatePicker, { registerLocale, setDefaultLocale } from "react-datepicker"
import type { ReactDatePickerProps } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

registerLocale("ja", ja)
setDefaultLocale("ja")

const DatePicker = ({ dateFormat = "yyyy/MM/dd", ...props }: ReactDatePickerProps) => {
  return <ReactDatePicker dateFormat={dateFormat} {...props} popperClassName={style} />
}

export default DatePicker

const style = css`
  z-index: 100;
`
